// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DownloadButton_wrap__1q1JZ","logo":"DownloadButton_logo__jjrwn","text":"DownloadButton_text__3mpUS"};